<script lang="ts">
	import Modal from '$lib/public/Modal.svelte'
	import Orange3D from '$lib/public/Orange3D.svelte'

	interface Props {
		location: StudioLocation
	}

	let { location }: Props = $props()
</script>

<Modal id="locationModal{location.id}" large={false} title={location.name}>
	{#if location.name !== 'Online'}
		<div class="tw:grid tw:grid-cols-1 tw:gap-4 tw:mb-4">
			<Orange3D class="tw:mx-auto">
				<a href={location.directions} title="Directions" rel="noreferrer" target="_blank"
					>Directions</a>
				<a href={location.review} title="Link to review" rel="noreferrer" target="_blank"
					>Review Us</a>
			</Orange3D>
			<span>
				{location.address}<br />
				{location.city}, {location.state}
				{location.zipCode}
			</span>
		</div>

		<iframe src={location.map} title="Google Maps" height="450" width="100%" allow="fullscreen"
		></iframe>
	{/if}

	<a
		class="tw:mt-3 tw:flex tw:items-center tw:gap-2 tw:no-underline"
		href="tel:{location.phone}"
		title="Location phone">
		<svg width="16" height="16" role="img">
			<title>Mobile phone icon</title>
			<use href="/images/icons/icons.svg#phone" />
		</svg>
		<span>{location.phone}</span>
	</a>
</Modal>
